import { mount } from 'enzyme';
import * as React from 'react';

import { Button } from './button';

describe('Button', () => {
  test('should match snapshot and styles for default props', () => {
    expect(mount(<Button text={'click'} name={'button1'} />)).toMatchSnapshot();
  });

  test('should match snapshot with label', () => {
    expect(mount(<Button text={'click'} name="button1" />)).toMatchSnapshot();
  });

  test('should match snapshot with disabled', () => {
    expect(
      mount(<Button text={'click'} name="button1" disabled={true} />),
    ).toMatchSnapshot();
  });

  test('With ellipsis', () => {
    expect(
      mount(<Button text={'click'} name={'button1'} ellipsis={true} />),
    ).toMatchSnapshot();
  });
});
